import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
// redux
import { Provider } from "react-redux";
import store from "./store/index";

// router

import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
